import { render, staticRenderFns } from "./ConsentTypes.vue?vue&type=template&id=3f8017ca&"
import script from "./ConsentTypes.vue?vue&type=script&lang=js&"
export * from "./ConsentTypes.vue?vue&type=script&lang=js&"
import style0 from "./ConsentTypes.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports